// CANapps Core
export const ROUTE_HOME = '/';
export const ROUTE_BASE = '/canappsv3';

// CANapps Entry
export const ROUTE_LOGIN = '/login';

// CANapps Management/Misc
export const ROUTE_DENIED = '/denied';
export const ROUTE_MENU_MGT = '/menus';
export const ROUTE_PROFILE = '/profile';
export const ROUTE_CHECKOUT = '/checkout';

// Contacts App
export const ROUTE_CONTACTS = '/contacts';

// Users App
export const ROUTE_USERS = '/users';

// CANdispatch App
export const ROUTE_CHECKLISTS = '/checklists';
export const ROUTE_SHIFT_RPT = '/shift-rpt';
export const ROUTE_INCIDENT_REPORT = '/generate-incident-report';
export const ROUTE_CAN_GUARD = '/CANguard';
export const ROUTE_SCHEDULER = '/scheduler';
export const ROUTE_GUARD_LOCATIONS = '/dispatch/guard-locations';
export const ROUTE_DISPATCH_NOTIFICATION_SETTINGS = '/dispatch/settings/notifications';

// CANpark App
export const ROUTE_CANPARK = '/canpark';
export const ROUTE_CANPARK_ADMIN = '/canpark-admin';

// CANshare App
export const ROUTE_CANSHARE = '/documents';

// CANstore App
export const ROUTE_CAN_STORE = '/can-store';

// Calendar App
export const ROUTE_CALENDAR = '/calendar';
export const ROUTE_TODO = '/todo';

// CANtrack App
export const ROUTE_CANTRACK = '/cantrack';
export const ROUTE_TIMESHEETS = '/timesheets';
export const ROUTE_CASES = '/cantrack/cases';
export const ROUTE_PAYROLL = '/cantrack/payroll';
export const ROUTE_KEYWORD_MANAGEMENT = '/cantrack/keyword-management';
export const ROUTE_ACTIVITY_LOG_MANAGEMENT = '/cantrack/activity-log-management';
export const ROUTE_COMMENTS = '/cantrack/comments';

// CANmail App
export const ROUTE_MAIL_LIST = '/listmanager';
export const ROUTE_UNSUBSCRIBE = '/unsubscribe';
export const ROUTE_EMAIL_SENDER = '/emailsender';
export const ROUTE_CONSENT_LOG = '/consent-log';
export const ROUTE_EMAIL_HISTORY = '/emailhistory';
export const ROUTE_EMAIL_TEMPLATES = '/email-templates';

// CANreports App
export const ROUTE_ANALYTICS_REPORT = '/analytics-report';
export const ROUTE_SALES_ANALYTICS = '/salesanalytics';

// CANprospect (CRM) App
export const ROUTE_CANPROSPECT = '/canprospect';
export const ROUTE_CANPROSPECT_EVENTS = '/canprospect/events';

// CANmeet App
export const ROUTE_MEET = '/meet';
export const ROUTE_MEETING = '/meeting';

// CANsurvey App
export const ROUTE_SURVEY_HOME = '/surveyhome';
export const ROUTE_CREATE_SURVEY = '/createsurvey';
export const ROUTE_PREVIEW_SURVEY = '/previewsurvey';
export const ROUTE_SURVEY = '/survey';

// CANsense App
export const ROUTE_SENSE = '/sense';
export const ROUTE_SENSE_DASHBOARD = '/sense/dashboard';
export const ROUTE_SENSE_MANAGEMENT = '/sense/management';
// Legacy routes (kept for redirects)
export const ROUTE_SENSE_MONITORING = '/sense/monitoring';
export const ROUTE_SENSE_EXPORTERS = '/sense/exporters';
export const ROUTE_SENSE_WEBSITES = '/sense/websites';

// CANblog App
export const ROUTE_CANBLOG = '/canblog';
export const ROUTE_CANBLOG_EDITOR = '/canblog/editor';

// CANai App
export const ROUTE_CANAI = '/canai';
export const ROUTE_ACTIVITY_REPORT = '/activity-report';

// CANvision App (formerly CANVMS)
export const ROUTE_CANVISION = '/canvision';
export const ROUTE_CANVISION_VIDEO_WALL = '/canvision/video-wall';
export const ROUTE_CANVISION_EVENTS = '/canvision/events';
export const ROUTE_CANVISION_INCIDENTS = '/canvision/incidents';
// Keep for backward compat during transition:
export const ROUTE_CANVMS = ROUTE_CANVISION;

// Customer Management
export const ROUTE_CUSTOMERS = '/customers';

// Address Management
export const ROUTE_ADDRESS_MANAGEMENT = '/addresses';

// Announcement Management
export const ROUTE_ANNOUNCEMENT_MANAGEMENT = '/announcements';

// Downloads
export const ROUTE_DOWNLOADS = '/downloads';

// File Manager
export const ROUTE_FILEBUCKET_MANAGER = '/file-manager';

// Case Management (GPDA Bulk Reassignment)
export const ROUTE_CASE_MANAGEMENT = '/case-management';

// CANdocs App
export const ROUTE_CANDOCS = '/docs';

// Admin
export const ROUTE_INSTANCE_SETTINGS = '/instance-settings';

// Quantum Healing
export const ROUTE_QUANTUM_HEALING_PARTICIPANTS = '/quantum-healing-participants';
